import { QuestionPlanIsHiddenHotelQuestions as Question } from "@/components/features/items/edit/plan/_shared/ui/components/pre-questions/is-hidden-hotel-questions";

import { usePlanIsHiddenHotelQuestions } from "./hooks";

export const QuestionPlanIsHiddenHotelQuestions = () => {
	const { questions, isHiddenHotelQuestions, onSetIsHiddenHotelQuestions } = usePlanIsHiddenHotelQuestions();

	return (
		<Question
			questions={questions}
			isHiddenHotelQuestions={isHiddenHotelQuestions}
			onSetIsHiddenHotelQuestions={onSetIsHiddenHotelQuestions}
		/>
	);
};

QuestionPlanIsHiddenHotelQuestions.displayName = "QuestionPlanIsHiddenHotelQuestions";
